var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27175 13.7135C1.27196 15.3798 2.47225 17.4997 4.41548 17.4997H15.5845C17.5278 17.4997 18.7281 15.3798 17.7283 13.7135L12.1437 4.40594C11.1727 2.7876 8.82728 2.7876 7.85627 4.40594L2.27175 13.7135Z",
    fill: "#C70032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.6664C10.4602 6.6664 10.8333 7.03949 10.8333 7.49973V10.8331C10.8333 11.2933 10.4602 11.6664 10 11.6664C9.53976 11.6664 9.16667 11.2933 9.16667 10.8331V7.49973C9.16667 7.03949 9.53976 6.6664 10 6.6664ZM10 14.9997C9.30964 14.9997 8.75 14.4401 8.75 13.7497C8.75 13.0594 9.30964 12.4997 10 12.4997C10.6904 12.4997 11.25 13.0594 11.25 13.7497C11.25 14.4401 10.6904 14.9997 10 14.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0415c2f9b88d48ced4862f836ed5f32b.svg";
export { ForwardRef as ReactComponent };